import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Home from './pages/Home';
import CatalogEnquiries from './pages/CatalogEnquiries';
import ConsultantEnquiries from './pages/ConsultantEnquiries';
import PrivateRouter from './routers/PrivateRouter';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/signin" element={<Login />} />
        
        {/* Protected Admin Routes */}
        <Route element={<PrivateRouter />}>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<Home />} />
          <Route path="/catalog-enquiries" element={<CatalogEnquiries />} />
          <Route path="/consultant-enquiries" element={<ConsultantEnquiries />} />
        </Route>

        {/* Fallback route */}
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
